// extracted by mini-css-extract-plugin
export default {"wrapper":"StickyPageLayout_wrapper__dMg6R","header":"StickyPageLayout_header__udVGb","title":"StickyPageLayout_title__Ki7hl","content":"StickyPageLayout_content__hU0b+"};